import React from 'react';
import styled from 'styled-components';

import { formatPrice } from '@src/utils/price';
import { ViewsIcon } from '@src/components/common/icon';

const ViewsWrapper = styled.div`
	display: flex;
	align-items: center;
	color: #676767;

	.views__number {
		font-size: 14px;
		margin-left: 8px;
	}
`;

interface IViews {
	views: number;
}

const Views = ({ views }: IViews): JSX.Element => (
	<ViewsWrapper>
		<ViewsIcon />
		<span className="views__number">{formatPrice(views)}</span>
	</ViewsWrapper>
);

export default Views;
